import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Dropdown, Menu } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import "./Main.css";
import * as links from "../../../utils/links";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faServer,
  faXmark,
  faBars,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import MainSidebar from './MainSideMenu/MainSidebar';
const Main = (props) => {
  const { children } = props;
  const { setDataUser, loading, authInfo } = useContext(AuthContext);

  const location = useLocation();
  let navigate = useNavigate();

  const { dataUser } = authInfo;

  const [isOpen, setIsOpen] = useState(false);
  const [showOpportunity, setShowOpportunity] = useState(false);
  const opportunityImages = useMemo(
    () => [
      `${process.env.PUBLIC_URL || ""}/oportunidade-cliente.jpeg`,
      `${process.env.PUBLIC_URL || ""}/oportunidade-cliente2.jpeg`,
    ],
    []
  );
  const [opportunityImageSrc, setOpportunityImageSrc] = useState(opportunityImages[0]);
  const opportunityWhatsappUrl = useMemo(() => {
    const text =
      "Olá! Vi a oportunidade dentro do sistema IKPay e quero saber mais sobre a máquina preta personalizada.";
    return `https://wa.me/5519991501104?text=${encodeURIComponent(text)}`;
  }, []);

  const opportunitySessionKey = useMemo(() => {
    const userKey =
      dataUser?.id || dataUser?.email || dataUser?.nome || dataUser?.name || "client";
    const loginKey = dataUser?.token || authInfo?.dataUser?.token || "login";
    return `ik-client-opportunity-shown:${userKey}:${loginKey}`;
  }, [authInfo?.dataUser?.token, dataUser]);
  const opportunityDisabledKey = useMemo(() => {
    const userKey =
      dataUser?.id || dataUser?.email || dataUser?.nome || dataUser?.name || "client";
    return `ik-client-opportunity-disabled:${userKey}`;
  }, [dataUser]);

  useEffect(() => {
    document.body.classList.add("ik-admin-theme");
    return () => {
      document.body.classList.remove("ik-admin-theme");
    };
  }, []);

  useEffect(() => {
    if (dataUser?.key !== "CLIENT") {
      setShowOpportunity(false);
      return undefined;
    }

    if (localStorage.getItem(opportunityDisabledKey) === "1") {
      setShowOpportunity(false);
      return undefined;
    }

    if (sessionStorage.getItem(opportunitySessionKey)) {
      return undefined;
    }

    sessionStorage.setItem(opportunitySessionKey, "1");
    setOpportunityImageSrc(
      opportunityImages[Math.floor(Math.random() * opportunityImages.length)]
    );
    setShowOpportunity(true);

    const timeoutId = window.setTimeout(() => {
      setShowOpportunity(false);
    }, 20000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [dataUser, opportunityDisabledKey, opportunityImages, opportunitySessionKey]);

  const handleDisableOpportunity = () => {
    localStorage.setItem(opportunityDisabledKey, "1");
    setShowOpportunity(false);
  };

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <div
              onClick={() => {
                setDataUser(null);
              }}
            >
              Sair
            </div>
          ),
        },
      ]}
    />
  );
  return (
    <>
      {showOpportunity && dataUser?.key === "CLIENT" ? (
        <div className="Main_opportunityOverlay" role="dialog" aria-modal="true" aria-label="Oportunidade">
          <div className="Main_opportunityCard">
            <button
              type="button"
              className="Main_opportunityClose"
              onClick={() => setShowOpportunity(false)}
              aria-label="Fechar oportunidade"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <img
              className="Main_opportunityImage"
              src={opportunityImageSrc}
              alt="Oportunidade para personalizar a maquina"
              onError={() => {
                const fallbackImage =
                  opportunityImageSrc === opportunityImages[0]
                    ? opportunityImages[1]
                    : opportunityImages[0];
                if (fallbackImage !== opportunityImageSrc) {
                  setOpportunityImageSrc(fallbackImage);
                }
              }}
            />
            <a
              className="Main_opportunityCta"
              href={opportunityWhatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Não perca essa oportunidade clique aqui
            </a>
            <button
              type="button"
              className="Main_opportunitySecondaryAction"
              onClick={handleDisableOpportunity}
            >
              Não mostrar novamente
            </button>
            <div className="Main_opportunityFooter">
              Oferta exibida por 20 segundos ao entrar no sistema.
            </div>
          </div>
        </div>
      ) : null}
      <div className="Main_container">
        <MainSidebar />
        {/* <div className={`Main_sidebar ${isOpen ? "open" : ""}`}>
          <button
            type="button"
            className="sidebar-burger"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <FontAwesomeIcon icon={faXmark} className="icon fa-2x" />
            ) : (
              <FontAwesomeIcon icon={faBars} className="icon fa-2x" />
            )}
          </button>
          <div className={`Main_menuProfile ${isOpen ? "open" : ""}`}>
            <div className="circle-icon">
              <span>LC</span>
            </div>
          </div>

          <Link
            to={
              dataUser?.key === "CLIENT"
                ? links.DASHBOARD_FORNECEDOR
                : links.DASHBOARD_CLIENTES
            }
            className={`Main_menuitemLink ${isOpen ? "open" : ""} ${
              dataUser?.key === "ADMIN" ? "admin" : ""
            }`}
          >
            <div className="Main_menuitem">
              <FontAwesomeIcon icon={faServer} className="icon" />
              <div className={`SidebarMaquina ${isOpen ? "open" : ""}`}>
                {dataUser?.key === "CLIENT" ? `Maquinas` : `Clientes`}
              </div>
            </div>
          </Link>
          {
            dataUser?.key === "ADMIN" ?
            <Link
              to={
                links.LISTA_MAQUINAS
              }
              className={`Main_menuitemLinkSecond ${isOpen ? "open" : ""} ${
                dataUser?.key === "ADMIN" ? "admin" : ""
              }`}
            >
              <div className="Main_menuitem">
                <FontAwesomeIcon icon={faServer} className="icon" />
                <div className={`SidebarMaquina ${isOpen ? "open" : ""}`}>
                  Máquinas
                </div>
              </div>
            </Link>
            :
            ''
          }
          {
            dataUser?.key === "CLIENT" ?
            <Link
              to={
                links.NEW_PASSWORD
              }
              className={`Main_menuitemLinkSecond ${isOpen ? "open" : ""}`}
            >
              <div className="Main_menuitem">
                <FontAwesomeIcon icon={faServer} className="icon" />
                <div className={`SidebarMaquina ${isOpen ? "open" : ""}`}>
                  Trocar senha
                </div>
              </div>
            </Link>
            :
            ''
          }
          {
            dataUser?.key === "CLIENT" ?
            <Link
              to={
                links.CLIENTE_PAGAMENTOS
              }
              className={`Main_menuitemLinkSecond ${isOpen ? "open" : ""}`}
            >
              <div className="Main_menuitem">
                <FontAwesomeIcon icon={faServer} className="icon" />
                <div className={`SidebarMaquina ${isOpen ? "open" : ""}`}>
                  Pagamentos
                </div>
              </div>
            </Link>
            :
            ''
          }
          <div className={`Main_header ${isOpen ? "open" : ""}`}>
            <div
              className="Main_headerRight"
              onClick={() => {
                navigate(
                  dataUser?.key === "CLIENT" ? links.SIGNIN : links.ADMIN_SIGNIN
                );
                setDataUser(null);
              }}
            >
              <div className="Main_headerSearch">
                <span style={{ fontSize: "12px" }}>{dataUser.name}</span>
                <FontAwesomeIcon
                  className="icon"
                  style={{ marginLeft: "5px" }}
                  icon={faRightFromBracket}
                ></FontAwesomeIcon>
              </div>
            </div>
          </div>
        </div> */}
        <div className="Main_right">
          <div
            className="Main_content"
            style={{ marginTop: "30px", marginLeft: "-10px" }}
          >
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
